export default "__VITE_ASSET__D51z6EYj__"